import { useRoutingContext } from 'app/routing_context'
import { useFileDetails } from 'file_folder_repository/queries/details'
import { useGenerateFileReport } from 'file_folder_repository/queries/generate_report'
import { useFileAcknowledgements } from 'file_folder_repository/queries/list'
import { GenerateFileReportParams } from 'file_folder_repository/queries/shared/types'
import { FileAcknowledgementsScreenProps } from 'home/stack/types'
import React, { useCallback, useState } from 'react'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { FileAcknowledgementsView } from './views'

export function FileAcknowledgementsScreen({
  route,
}: FileAcknowledgementsScreenProps) {
  const { fileId } = route.params
  const fileDetailsQuery = useFileDetails(fileId)
  const fileAcknowledgementsQuery = useFileAcknowledgements(fileId)
  const generateReportMutation = useGenerateFileReport()
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)
  const { handleNavigation } = useRoutingContext()

  const handleGenerateReport = useCallback(
    async (type: GenerateFileReportParams['type']) => {
      try {
        setIsGeneratingReport(true)
        await generateReportMutation.mutateAsync({ fileId, type })
      } catch (error) {
        errorAlert(error)
      } finally {
        setIsGeneratingReport(false)
      }
    },
    [generateReportMutation, fileId]
  )

  const onPressThumbnail = useCallback(() => {
    if (fileDetailsQuery.data) {
      handleNavigation({
        routeName: 'file_viewer',
        routeParams: { fileId: fileDetailsQuery.data.id },
      })
    }
  }, [fileDetailsQuery.data, handleNavigation])

  return (
    <StatusBoundary
      isLoading={fileDetailsQuery.isLoading}
      error={fileDetailsQuery.error}
    >
      <FileAcknowledgementsView
        file={fileDetailsQuery.data}
        acknowledgements={fileAcknowledgementsQuery.data}
        onGenerateReport={handleGenerateReport}
        isGeneratingReport={isGeneratingReport}
        onPressThumbnail={onPressThumbnail}
      />
    </StatusBoundary>
  )
}
